<template>
  <div>
    <b-modal v-model="modalShow" :title="title" hide-footer>
      <form>
        <div class="form-group">
          <div class="border p-2 mt-3 text-center">
            <p>{{ 'Preview' }}</p>
            <template>
              <img
                :src="preview || require(`@/assets/images/NoImage.jpg`)"
                class="img-fluid"
                style="max-height:300px;"
              />
              <!-- <p v-if="preview" class="mb-0">file name: {{ image.name }}</p>
              <p v-if="preview" class="mb-0">size: {{ image.size / 1024 }}KB</p> -->
            </template>
          </div>
          <b-row class="mt-3">
            <b-col sm="12" md="12">
              <b-form-file
                ref="file-input"
                placeholder="Choose a image or drop it here..."
                drop-placeholder="Drop image here..."
                :accept="acceptType"
                @change="previewImage"
                :disabled="!!image"
                v-show="!url"
              ></b-form-file>
              <b-input-group v-if="url" class="mt-3">
                <b-form-input
                  ref="name-input"
                  v-model="url"
                  type="url"
                  @focus="$event.target.select()"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="onCopy"
                    id="tooltip-target-1"
                    variant="light"
                    ><i class="fas fa-copy"></i
                  ></b-button>
                  <b-tooltip target="tooltip-target-1" triggers="hover">
                    {{ textCopy }}
                  </b-tooltip>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col sm="12" md="12" class="p-3"
              ><b-button
                block
                variant="warning"
                v-if="!!image && !url"
                @click="reset"
              >
                Change Image
              </b-button>
            </b-col>
            <b-col sm="12" md="6" class="p-3">
              <b-button
                block
                variant="primary"
                v-if="!url"
                @click="uploadImage"
                :disabled="!canUpload"
              >
              <i class="bx bx-cloud-upload"></i>  Upload
              </b-button>
              <!-- <b-button block variant="primary" @click="onCopy" v-if="!!url" :disabled="!url">
                Copy URL
              </b-button> -->
              <b-button
                block
                variant="info"
                @click="reset"
                v-if="!!url"
                :disabled="!url"
              >
                Try New Image
              </b-button>
            </b-col>
            <b-col sm="12" md="6" class="p-3"
              ><b-button
                block
                @click="
                  modalShow = false;
                  reset()
                "
                >Close
              </b-button>
            </b-col>
          </b-row>
          <!-- <label for="my-file">Select Image</label>
          <input
            type="file"
            accept="image/*"
            @change="previewImage"
            class="form-control-file"
            id="my-file"
          /> -->
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { eventBus } from '@/main.js'
import filecloudService from '@/helpers/service/filecloud-service'
import Vue from 'vue'
export default {
  name: 'modalImageSingleUpload',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Upload Image Helper',
    },
    acceptType: {
      type: String,
      default: '.jpg, .jpeg, .png',
    },
    path: {
      type: String,
      default: () => {
        return 'products/nocontent'
      },
    },
    contentDescription: {
      type: String,
      default: () => {
        return 'pim-no-content'
      },
    },
    maxHeight: {
      type: String,
      default: () => {
        return '0'
      },
    },
    maxWidth: {
      type: String,
      default: () => {
        return '0'
      },
    },
    maxSize: {
      type: String,
      default: () => {
        return '3248000'
      },
    },
    isUpsert: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      preview: null,
      image: null,
      canUpload: false,
      url: '',
      textCopy: 'Copy',
    }
  },
  created() {
    // console.log(this.modalShow)
  },
  computed: {
    modalShow: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    textCopy: {
      handler(value) {
        // console.log(value)
        if (value === 'Copied!') {
          setTimeout(() => {
            this.textCopy = 'Copy'
          }, 5000)
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  methods: {
    previewImage: function(event) {
      let maxHeight = this.maxHeight
      let maxWidth = this.maxWidth
      var vm = this
      var input = event.target
      const file = event.target.files[0]
      if (!input.files) {
        vm.$utils.notification('error', 'ไม่สามารถเลือกไฟล์ได้', 2000)
        return false
      }
      if (file.size > Number(this.maxSize)) {
        //around 3mb
        vm.$utils.notification('error', 'ขนาดไฟล์ไม่เหมาะสม', 2000)
        return false
      }
      if (!file.type.match(/image.*/)) {
        vm.$utils.notification('error', 'ชนิดไฟล์ไม่เหมาะสม', 2000)
        return false
      }

      var reader = new FileReader()
      reader.onload = readerEvent => {
        this.preview = readerEvent.target.result

        var image = new Image()
        image.onload = async function(imageEvent) {
          if (
            (Number(image.height) >= Number(maxHeight) ||
              Number(image.width) >= Number(maxWidth)) &&
            Number(maxHeight) != 0 &&
            Number(maxWidth) != 0
          ) {
            console.log('maxHeight', maxHeight)
            console.log('maxWidth', maxWidth)
            vm.$utils.notificationAck(
              'error',
              `ขนาดรูปไม่เหมาะสม (${Number(image.height)} x ${Number(
                image.width
              )})`
            )
            return false
          }
          vm.canUpload = true
          return true
          // console.log('5555');
          // await vm.uploadImage(file)
        }
        image.src = readerEvent.target.result
      }
      vm.image = input.files[0]
      reader.readAsDataURL(input.files[0])
    },
    reset: function() {
      this.image = null
      this.preview = null
      this.canUpload = false
      this.url = null
      this.$refs['file-input'].reset()
    },
    async uploadImage() {
      const file = this.image
      var sp = file.name.split('.')
      var extension = `.${sp[sp.length - 1]}`
      // var _fname = file.name.replace(extension, '')
      var fileName = `${this.toSeoUrl(this.contentDescription)}${extension}`
      let dataOriginal = new FormData()
      dataOriginal.append('file', file, fileName)
      dataOriginal.append('bucket', `${process.env.VUE_APP_BUCKET_PIM}`)
      dataOriginal.append('path', this.path)
      dataOriginal.append('key', fileName)
      dataOriginal.append('content_description', this.contentDescription)
      dataOriginal.append('is_upsert', this.isUpsert)
      let resultUploadOriginal = await filecloudService.uploadImageAsync(
        dataOriginal
      )
      eventBus.$emit('changeLoadingState', false)
      if (resultUploadOriginal.status === 201) {
        this.url = resultUploadOriginal.data.content_cdn_url
        // console.log(this.url)
        // this.modelChanged()
        // if (this.isPopupModal) {
        //   this.$bvModal.show('modal-prevent-closing')
        // }
      } else {
        this.$utils.notificationConfirm('error', 'ไม่สามารถ Upload ไฟล์')
      }
    },
    toSeoUrl(url) {
      // make the url lowercase
      var encodedUrl = url.toString().toLowerCase()

      // replace & with and
      encodedUrl = encodedUrl
        .split(/\&+/) /* eslint-disable-line */
        .join('-and-') /* eslint-disable-line */

      // remove invalid characters
      encodedUrl = encodedUrl
        .split(/[^a-z0-9]/) /* eslint-disable-line */
        .join('-') /* eslint-disable-line */

      // remove duplicates
      encodedUrl = encodedUrl.split(/-+/).join('-') /* eslint-disable-line */

      // trim leading & trailing characters
      encodedUrl = encodedUrl.trim('-')

      return this.toFormatDate(encodedUrl)
    },
    toFormatDate(filename) {
      var nowDate = new Date()
      var exportDate = nowDate
        .toISOString()
        .replace(/-/g, '')
        .split('T')[0]
      var exportHour = (nowDate.getHours() < 10 ? '0' : '') + nowDate.getHours()
      var exportMinute =
        (nowDate.getMinutes() < 10 ? '0' : '') + nowDate.getMinutes()
      var exportSeconds =
        (nowDate.getSeconds() < 10 ? '0' : '') + nowDate.getSeconds()
      var exportFileName =
        filename +
        '-' +
        exportDate +
        '-' +
        exportHour +
        exportMinute +
        exportSeconds
      return exportFileName.replace('--', '-')
    },
    onCopy() {
      let input = this.$refs['name-input']
      input.select()
      document.execCommand('copy')
      this.textCopy = 'Copied!'
    },
  },
}
</script>

<style scoped></style>
